(function () {
	'use strict';
	$(document).ready(function () {
		function getCities(voivodeship) {
			const nonce = fhGetConfig('nonce');

			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				method: 'post',
				timeout: 10000,
				data: {
					action: 'get_cities',
					voivodeship: voivodeship,
					nonce: nonce,
				},
				success: function (data) {
					$('.filter-form-filters').append(data);
				},
				error: function () {
				},
				beforeSend: function () {
					$('#filter-form-group-cities').remove();
					$('.filter-form-filters').append('<div class="ajax-loader"></div>');
				},
				complete: function () {
					$('.filter-form-filters .ajax-loader').remove();
					$('#filter-form-search').attr('disabled', false);
					$('#filter-form-clear').attr('disabled', false);
				},
			});
		}

		$(document).on('change', '#projects-voivodeship', function () {
			const voivodeship = $('select[name="projects-voivodeship"]').val();
			$('#filter-form-search').attr('disabled', true);
			$('#filter-form-clear').attr('disabled', true);
			getCities(voivodeship);
		});

	});
}(jQuery));
